<div class="d-inline-block" ngbDropdown display="dynamic" placement="bottom-end top-end">

	<!-- Selected Language & Toggle	-->
	<span class="align-middle no-dropdown-icon fs-24" ngbDropdownToggle>
		<span
			[attr.title]="languageSelectPlaceholder"
			class="d-inline-block languageSelectLabel align-middle action-value me-2"
		>
			{{
			languageSelectPlaceholder && !selectedLanguageLocalName
			? languageSelectPlaceholder ?? '-'
			: selectedLanguageLocalName ?? '-'
			}}
		</span>
		<i class="align-middle ft-chevron-down"></i>
	</span>

	<!-- Menu -->
	<div ngbDropdownMenu>
		<a class="dropdown-item py-1"
			 ngbDropdownItem
			 *ngFor="let language of supportedLanguages"
			 (click)="onLanguageChange(language)"
			 [ngClass]="{'selected': selectedLanguageLocalName === language?.localName}">

			<!-- Flag -->
			<img
				src="./assets/img/flags/{{ language?.flag }}.png"
				[alt]="language?.localName"
				class="langimg me-2"
			>

			<!-- Language -->
			<span>{{ language?.localName | uppercase }}</span>
		</a>
	</div>
</div>
